function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classNames from 'classnames';
import React, { useCallback } from 'react';
import { BackgroundIcon, ButtonWrapper, IconWrapper, TextWrapper } from "./Button.styles";
import { ButtonTypes } from "./Button.types";
export var Button = function Button(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      Icon = _ref.icon,
      onClick = _ref.onClick,
      style = _ref.style,
      type = _ref.type,
      htmlType = _ref.htmlType,
      iconAfterText = _ref.iconAfterText,
      rest = _objectWithoutProperties(_ref, ["className", "children", "disabled", "icon", "onClick", "style", "type", "htmlType", "iconAfterText"]);

  var handleClick = useCallback(function (e) {
    return onClick && onClick(e);
  }, [onClick]);
  var icon = Icon ? typeof Icon === 'string' ? React.createElement(BackgroundIcon, {
    className: "button__icon",
    size: "extraLarge",
    icon: Icon
  }) : Array.isArray(Icon) ? React.createElement(BackgroundIcon, {
    className: "button__icon",
    size: Icon[0],
    icon: Icon[1]
  }) : React.isValidElement(Icon) ? Icon : React.createElement(Icon) : undefined;
  return React.createElement(ButtonWrapper, _extends({
    className: classNames(className, 'button', "button--".concat(typeof type === 'string' ? type : ButtonTypes[type || ButtonTypes.PRIMARY].toLowerCase()), disabled && 'button--disabled'),
    disabled: disabled,
    onClick: !disabled && onClick ? handleClick : undefined,
    style: style,
    type: htmlType,
    ruleSet: type,
    iconOnly: icon && !children ? true : undefined
  }, rest), icon && !iconAfterText && React.createElement(IconWrapper, {
    className: "button__icon-wrapper"
  }, icon), children && React.createElement(TextWrapper, {
    className: "button__text-wrapper"
  }, children), icon && iconAfterText && React.createElement(IconWrapper, {
    className: "button__icon-wrapper"
  }, icon));
};
Button.types = ButtonTypes;